import {FormControl, FormGroup} from '@angular/forms';

export abstract class BaseAbstract {

    public process(): (control: FormGroup | FormControl) => { [key: string]: any } {
        return this.validate().bind(this);
    }

    // ########################################

    protected abstract validate(): (control: FormGroup | FormControl) => { [key: string]: any };

    // ########################################
}
